import React, { useEffect, useState } from 'react';
import { Badge } from 'reactstrap';

const ParagraphComparison = ({ original, userInput }) => {
    const [comparisonResult, setComparisonResult] = useState([]);
    const [mistakesCount, setMistakesCount] = useState(0);

    useEffect(() => {
        if (original && userInput) {
            compareParagraphs();
        }
    }, [original, userInput]);

    // const compareParagraphs = () => {
    //     const originalWords = original.trim().replace(/\s+/g, " ").split(" ");
    //     const userWords = userInput.trim().replace(/\s+/g, " ").split(" ");

    //     const maxLength = Math.max(originalWords.length, userWords.length);
    //     const wordComparison = new Array(maxLength); // Preallocate memory for the array

    //     let mistakes = 0;

    //     for (let i = 0; i < maxLength; i++) {
    //         const originalWord = originalWords[i] || "";
    //         const userWord = userWords[i] || "";

    //         const isCorrect = userWord === originalWord;

    //         if (!isCorrect) mistakes++;

    //         // Store the result directly in the preallocated array
    //         wordComparison[i] = {
    //             userWord,
    //             originalWord,
    //             isCorrect,
    //         };
    //     }

    //     setComparisonResult(wordComparison);
    //     setMistakesCount(mistakes);
    // };

    const compareParagraphs = () => {
        const originalWords = original.trim().replace(/\s+/g, " ").split(" ");
        const userWords = userInput.trim().replace(/\s+/g, " ").split(" ");

        let originalIndex = 0;
        let userIndex = 0;

        const wordComparison = [];
        let mistakes = 0;

        while (originalIndex < originalWords.length || userIndex < userWords.length) {
            const originalWord = originalWords[originalIndex] || "";
            const userWord = userWords[userIndex] || "";

            if (originalWord === userWord) {
                wordComparison.push({
                    userWord,
                    originalWord,
                    isCorrect: true,
                });
                originalIndex++;
                userIndex++;
            } else if (
                originalWords[originalIndex + 1] === userWord &&
                originalWords[originalIndex + 1] !== undefined
            ) {
                wordComparison.push({
                    userWord: "",
                    originalWord,
                    isCorrect: false,
                });
                mistakes++;
                originalIndex++;
            } else if (
                userWords[userIndex + 1] === originalWord &&
                userWords[userIndex + 1] !== undefined
            ) {
                // User added an extra word
                wordComparison.push({
                    userWord,
                    originalWord: "",
                    isCorrect: false,
                });
                mistakes++;
                userIndex++;
            } else {
                wordComparison.push({
                    userWord,
                    originalWord,
                    isCorrect: false,
                });
                mistakes++;
                originalIndex++;
                userIndex++;
            }
        }

        setComparisonResult(wordComparison);
        setMistakesCount(mistakes);
    };

    return (
        <div>
            <p><strong>Your Response:</strong></p>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {comparisonResult?.map(({ userWord, isCorrect }, index) => (
                    <span key={index} style={{ color: isCorrect ? "black" : "red", marginRight: "5px", }}>
                        {userWord || <span style={{ color: "gray" }}>{" "}</span>}
                        {!isCorrect && userWord && (
                            <Badge
                                color="danger"
                                style={{ marginLeft: "3px", fontSize: "0.8em" }}
                            >
                                Mistake
                            </Badge>
                        )}
                    </span>
                ))}
            </div>
            <p style={{ marginTop: '10px' }}>
                <strong>Mistakes:</strong> {userInput?.length ? mistakesCount : "No user input"}
            </p>
        </div>
    );
};

export default ParagraphComparison;